var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOs1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 79,
    viewBox: "0 0 100 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4211 68.4482H7.21484C5.59687 68.4482 4.28516 69.76 4.28516 71.3779V76.5721C4.28516 77.1113 4.72246 77.5486 5.26172 77.5486H94.3121C94.8514 77.5486 95.2887 77.1113 95.2887 76.5721V71.3779C95.2887 69.76 93.9769 68.4482 92.359 68.4482H19.4523",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7834 41.1474C51.4587 41.1474 52.8168 39.7893 52.8168 38.114C52.8168 36.4387 51.4587 35.0806 49.7834 35.0806C48.1081 35.0806 46.75 36.4387 46.75 38.114C46.75 39.7893 48.1081 41.1474 49.7834 41.1474Z",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.885 38.1138V37.9163C58.885 37.6515 58.9924 37.398 59.1826 37.214L61.0358 35.4222C61.4904 34.9825 61.5877 34.2897 61.2713 33.7419L59.3141 30.352C58.9979 29.8042 58.3492 29.5421 57.7412 29.7159L55.2647 30.4243C55.01 30.4972 54.7365 30.4634 54.507 30.3308L54.1621 30.1312C53.9332 29.9987 53.7678 29.7792 53.7037 29.5228L53.0791 27.0241C52.9258 26.4105 52.3742 25.98 51.7418 25.98H47.8276C47.1949 25.98 46.6436 26.4105 46.4903 27.0241L45.8656 29.5228C45.8016 29.7792 45.6362 29.9987 45.4072 30.1312L45.0623 30.3308C44.833 30.4634 44.5596 30.4972 44.3047 30.4243L41.8281 29.7159C41.2199 29.5419 40.5715 29.8042 40.2553 30.352L38.2981 33.7419C37.9819 34.2897 38.0789 34.9825 38.5336 35.4222L40.3867 37.214C40.5772 37.398 40.6846 37.6515 40.6844 37.9163V38.1138V38.3112C40.6844 38.5761 40.577 38.8296 40.3867 39.0136L38.5336 40.8054C38.0789 41.245 37.9817 41.9378 38.2981 42.4856L40.2553 45.8755C40.5715 46.4233 41.2201 46.6855 41.8281 46.5116L44.3047 45.8032C44.5594 45.7304 44.8328 45.7642 45.0623 45.8968L45.4072 46.0964C45.6362 46.2288 45.8016 46.4483 45.8656 46.7048L46.4903 49.2034C46.6436 49.8171 47.1951 50.2476 47.8276 50.2476H51.7418C52.3744 50.2476 52.9258 49.8171 53.0791 49.2034L53.7037 46.7048C53.7678 46.4483 53.9332 46.2288 54.1621 46.0964L54.507 45.8968C54.7363 45.7642 55.0098 45.7304 55.2647 45.8032L57.7412 46.5116C58.3494 46.6856 58.9979 46.4233 59.3141 45.8755L61.2713 42.4856C61.5875 41.9378 61.4904 41.245 61.0358 40.8054L59.1826 39.0136C58.9922 38.8296 58.8848 38.5761 58.885 38.3112V38.1138Z",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7852 19.9132V13.8462",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 16.8798L49.7834 13.8462L52.8168 16.8798",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9844 38.1138H86.1852",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1523 35.0806L86.1857 38.114L83.1523 41.1476",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5834 38.1138H13.3828",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4162 35.0806L13.3828 38.114L16.4162 41.1476",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2539 56.4097V68.4483",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2539 18.9272V49.3784",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31641 68.4483V18.9272",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.567 7.93848L49.2783 1.3168C49.6109 1.22773 49.9613 1.22773 50.2939 1.3168L97.593 13.9916C98.1162 14.1318 98.4268 14.6695 98.2867 15.1928L97.2184 19.1854C97.0783 19.7088 96.5402 20.0195 96.0168 19.8793L50.04 7.56035C49.8736 7.51582 49.6986 7.51582 49.5322 7.56035L3.55352 19.8793C3.03008 20.0195 2.49199 19.7088 2.35195 19.1854L1.2836 15.1928C1.14356 14.6695 1.4541 14.1318 1.97735 13.9916L17.8875 9.72832",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7852 56.3145V62.3813",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 59.3481L49.7834 62.3815L52.8168 59.3481",
    stroke: "#012060",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOs1);
export default __webpack_public_path__ + "static/media/os1.448f726a06ea6b6a8c53f5e0ca177a83.svg";
export { ForwardRef as ReactComponent };